export default {
    "it": {
        "rubinred": {
            "content": {
                "builder": {
                    "one_col": "Una colonna",
                    "two_col": "Due colonne",
                    "three_col": "Tre colonne",
                    "four_col": "Quattro colonne",
                    "thumb_list": "Lista thumb",
                    "pad_text": "Testo spaziato",
                    "divider": "Divisore",
                    "spacer": "Spaziatore",
                    "addBlockModal": {
                        "title": "Aggiungi elemento"
                    },
                    "cloneLanguageModal": {
                        "title": "Clona lingua",
                        "save": "Conferma",
                        "cancel": "Annulla"
                    },
                    "closeModal": {
                        "title": "Modifiche non salvate",
                        "message": "Sembra tu non abbia salvato tutte le tue modifiche. Vuoi salvarle?",
                        "back_editing": "Torna alle modifiche",
                        "discard_changes": "Cestina modifiche",
                        "save_changes": "Salva modifiche"
                    },
                    "editModal": {
                        "title": "Modifica sezione",
                        "tab_general": "Generali",
                        "tab_background": "Background",
                        "tab_design": "Design",
                        "tab_row": "Opzioni Riga",
                        "reset": "Resetta opzioni di default",
                        "cancel": "Annulla",
                        "save": "Ok",
                        "select_img": "Seleziona immagine",
                        "values_message": "Inserisci i valori seguiti dall'unità di misura. Es. 10px, 10%, etc.",
                        "row_message": "Queste opzioni sono disponibili solo nelle pagine <strong>full width</strong>. Puoi abilitare la modalità full width nelle impostazioni della pagina."
                    },
                    "errors": {
                        "error_fetch": "C'è stato un problema durante il caricamento del contenuto.",
                        "error_catch": "C'è stato un problema durante il caricamento delle sezioni.",
                        "error_save": "C'è stato un problema durante il salvataggio del contenuto.",
                        "error_save_catch": "C'è stato un problema durante il salvataggio delle sezioni."
                    },
                    "messages": {
                        "delete_item_confirm_title": "Elimina sezione",
                        "delete_item_confirm_text": "Sei sicuro di voler rimuovere la sezione e tutti i suoi contenuti?",
                        "delete": "Elimina",
                        "cancel": "Annulla",
                        "item_duplicated": "La sezione è stata duplicata con sucesso!"
                    },
                    "edit": {
                        "yes": "Si",
                        "no": "No",
                        "background_color": "Background Color",
                        "background_image": "Background Image",
                        "background_position": "Background Position (x,y)",
                        "background_size": "Background Size",
                        "background_repeat": "Background Repeat",
                        "background_attachment": "Background Attachment",
                        "columns_valign": "Allineamento verticale colonne",
                        "columns_reverse": "Inverti colonne",
                        "columns_collapse": "Collassa colonne",
                        "hide_small": "Nascondi per mobile",
                        "center_small": "Testo centrato per mobile",
                        "css_box": "CSS Box",
                        "margin": "Margin",
                        "padding": "Padding",
                        "border": "Border",
                        "content": "Content",
                        "border_color": "Border Color",
                        "border_style": "Border Style",
                        "border_radius": "Border Radius",
                        "row_background": "Row Background",
                        "row_wrap": "Wrap row"
                    }
                }
            },
            "forms": {
                "forms": {
                    "message": {
                        "submission": {
                            "error": "Controlla la presenza di errori nel form."
                        }
                    }
                },
                "privacies": {
                    "common": {
                        "privacy_labels": {
                            "consent": "Do il consenso",
                            "do_not_consent": "Non do il consenso"
                        }
                    }
                }
            }
        },
        "frontend-message": {
            "delete_record": "Stai per cancellare questo record, vuoi continuare?",
            "not_logged_in": "Non sei loggato.",
            "loading": "Caricamento",
            "check_form": "Errore: controlla il modulo.",
            "something_wrong": "Ops, qualcosa è andato storto (:code). Se il problema persiste contattaci."
        },
        "frontend-action": {
            "add": "Aggiungi",
            "create": "Crea",
            "remove": "Rimuovi",
            "cancel": "Annulla",
            "delete": "Elimina",
            "edit": "Modifica",
            "submit": "Invia",
            "save": "Salva",
            "copy": "Copia",
            "paste": "Incolla",
            "update": "Aggiorna",
            "enable": "Abilita",
            "disable": "Disabilita",
            "install": "Installa",
            "uninstall": "Disinstalla",
            "open": "Apri",
            "close": "Chiudi",
            "collapse": "Apri/Chiudi",
            "upload": "Carica",
            "export": "Esporta",
            "preview": "Anteprima",
            "view": "Mostra",
            "play": "Play",
            "pause": "Pausa",
            "stop": "Stop",
            "select": "Seleziona",
            "select_language": "Seleziona lingua",
            "select_languages": "Seleziona lingue",
            "select_all": "Seleziona tutto",
            "select_element": "Seleziona un elemento...",
            "select_elements": "Seleziona uno o più elementi...",
            "drop_here": "Rilascia qui",
            "load_more": "Carica ancora",
            "send": "Invia",
            "share": "Condividi",
            "download": "Scarica",
            "back": "Indietro",
            "logout": "Logout",
            "bulk": {
                "delete": "Elimina Selezionati",
                "enable": "Abilita Selezionati",
                "disable": "Disabilita Selezionati"
            }
        },
        "frontend-common": {
            "error": "Errore",
            "success": "Successo",
            "info": "Info",
            "warning": "Attenzione",
            "danger": "Pericolo",
            "yes": "Sì",
            "no": "No",
            "all": "Tutto",
            "enabled": "Abilita",
            "disabled": "Disabilita",
            "installed": "Installato",
            "uninstalled": "Disinstallato",
            "actions": "Azioni",
            "bulk_actions": "Azioni di gruppo",
            "allow": "Permetti",
            "deny": "Nega",
            "inherit": "Eredita",
            "read_only": "Leggi solo",
            "reset": "Reset",
            "refresh": "Ricarica",
            "profile": "Profilo",
            "no_results": "Nessun risultato",
            "showing": "Mostra",
            "to": "a",
            "in": "in",
            "of": "di",
            "entries": "inserimenti",
            "loading": "Caricamento",
            "search": "Cerca",
            "filters": "Filtri",
            "order": "Ordina",
            "remove_filter": "Rimuovi filtro",
            "show_all": "mostra tutto",
            "show_enabled": "Mostra abilitati",
            "show_disabled": "mostra disabilitati",
            "show_more": "Mostra di più",
            "show_less": "Mostra meno",
            "all_enabled": "Tutti gli abilitati",
            "all_disabled": "Tutti i disabilitati",
            "per_page": "Per pagina",
            "language": "Lingua",
            "words_count": "{0} Nessuna parola|{1} Una parola|[2,Inf] :count parole",
            "preset": "Preset",
            "presets": "Presets",
            "privacy_policy": "Privacy policy",
            "company_info": "Company info",
            "safe_purchase": "Acquisto sicuro"
        },
        "frontend-mtg": {
            "filters": {
                "sectors": "Settori",
                "filter_products": "Filtra prodotti",
                "active_filters": "Filtri attivi",
                "filter_by": "Filtra per",
                "remove": "Rimuovi",
                "reset_all": "Azzera tutti i filtri",
                "apply": "Applica",
                "material": "Materiale",
                "liquid": "Liquido / Materiale",
                "regulations": "Normative",
                "applications": "Applicazioni"
            },
            "configurator": {
                "material": "Materiale",
                "application": "Applicazione",
                "sector": "Settore",
                "tube_type_standard": "Standard",
                "tube_type_special": "Speciale",
                "special_fitting": "Raccordo speciale",
                "special_text": "Nel passaggio successivo potrai caricare il disegno tecnico del raccordo speciale",
                "dimensions": "Dimensioni",
                "inner_dimensions": "Dimensioni interne in mm",
                "delivery_time": "Tempi di consegna in settimane",
                "connectors": "Raccordi",
                "summary": "Riepilogo",
                "inner_dimension_info_1": "Per valori fino a 254mm la lunghezza massima disponibile é 40m. Per valori superiori a 254mm la lunghezza massima disponibile é 12m.",
                "inner_dimension_info_2": "Per valori compresi tra 5 e 10mm e tra 150 e 200mm non sono disponibili raccordi standard.",
                "length_info_1": "Per valori fino a 12m la pressione massima é 15 BAR. Per valori superiori a 12m la pressione massima é 40 BAR.",
                "fitting_file_format": "I formati consentiti sono jpg, pdf, dxf (dimensione max. 2 Mbyte)",
                "fitting_file_right": "Carica il disegno del raccordo di destra",
                "fitting_file_left": "Carica il disegno del raccordo di sinistra",
                "select_file": "Seleziona il file",
                "file_fitting_right_field": "File raccordo destra",
                "file_fitting_left_field": "File file raccordo sinistra",
                "file_error": "File selezionato non valido. Selezionare un file in formato jpg, pdf o dxf e con dimensioni massime di 2Mb",
                "1_title": "Trova il tubo più adatto alle tue esigenze.<br>Scegli il <strong>materiale</strong> o il <strong>settore di applicazione.</strong>",
                "select_tube_size": "Scegli le <strong>dimensioni</strong> del tubo",
                "select_the": "Seleziona",
                "select": "Seleziona",
                "select_category": "Seleziona una categoria",
                "proceed": "Procedi",
                "back": "Indietro",
                "total_meters": "Lunghezza totale in metri",
                "total_length_meters": "Lunghezza totale per tubo in metri",
                "operating_pressure": "Pressione di esercizio in BAR",
                "select_connectors": "Scegli i <strong>raccordi</strong>",
                "select_dimension": "Seleziona dimensione raccordo",
                "left": "Sinistra",
                "left_connector": "Raccordo sinistro",
                "right": "Destra",
                "right_connector": "Raccordo destro",
                "no_connector": "Nessun raccordo",
                "order_summary": "Riepilogo ordine",
                "quantity": "Quantità",
                "company_name": "Nome azienda",
                "name": "Nome contatto",
                "phone": "Telefono",
                "province": "Provincia",
                "email": "Email",
                "notes": "Note",
                "select_tube_by": "Seleziona i tubi per",
                "inner_dimension": "Dimensioni interne",
                "total_length": "Lunghezza totale",
                "pressure": "Pressione",
                "connector_left_category": "Categoria raccordo sinistra",
                "connector_left_element": "Raccordo sinistra",
                "connector_left_size": "Misura raccordo sinistra",
                "connector_right_category": "Categoria raccordo destra",
                "connector_right_element": "Raccordo destra",
                "connector_right_size": "Misura raccordo destra",
                "special_connector_right_file": "File raccordo speciale destra",
                "special_connector_left_file": "File raccordo speciale sinistra",
                "submit": "Conferma",
                "material_item": "Specifica il tipo di materiale (facoltativo)",
                "email_subject": "Nuova richiesta configuratore",
                "email_text": "In seguito il riepilogo della richiesta del configuratore:",
                "material_label": "Materiale",
                "application_label": "Applicazione",
                "box": {
                    "title": "Progettiamo e produciamo tubi in gomma personalizzati per ogni esigenza",
                    "text": "Consigliamo, progettiamo e forniamo soluzioni personalizzate per soddisfare le vostre esigenze e specifiche."
                },
                "form_data": {
                    "standard": "Standard",
                    "special": "Raccordo speciale",
                    "material_1": "Gomma",
                    "material_2": "Silicone",
                    "material_3": "Termoplastici",
                    "material_4": "Fluoropolimeri",
                    "material_item_1": "EPDM",
                    "material_item_2": "NR",
                    "material_item_3": "NBR",
                    "material_item_4": "SBR",
                    "material_item_5": "FKM",
                    "material_item_6": "Platinico",
                    "material_item_7": "Perossidico",
                    "material_item_8": "upe",
                    "material_item_9": "Xlpe",
                    "material_item_10": "PU-etere",
                    "material_item_11": "Pu-estere",
                    "material_item_12": "Pu-antistatico",
                    "material_item_13": "PFA",
                    "material_item_14": "FEP",
                    "material_item_15": "PTFE",
                    "material_item_16": "PFA antistatico",
                    "material_item_17": "FEP antstatico",
                    "material_item_18": "PFE antistatico",
                    "alimentare": "Alimentare",
                    "farmaceutico": "Farmaceutico",
                    "chimico": "Chimico",
                    "ferroviario": "Ferroviario",
                    "pompe_peristaltiche_e_valvole": "Pompe peristaltiche e valvole",
                    "peristaltiche": "Peristaltiche",
                    "dragaggio_e_materiali_abrasivi": "Dragaggio e materiali abrasivi",
                    "inner_dimension_1": "Dimensioni interne 1",
                    "inner_dimension_2": "Dimensioni interne 2",
                    "inner_dimension_3": "Dimensioni interne 3",
                    "inner_dimension_4": "Dimensioni interne 4",
                    "inner_dimension_5": "Dimensioni interne 5",
                    "inner_dimension_6": "Dimensioni interne 6",
                    "inner_dimension_7": "Dimensioni interne 7",
                    "inner_dimension_8": "Dimensioni interne 8",
                    "delivery_time_1": "Urgente",
                    "delivery_time_2": "Standard (3-6 settimane)",
                    "delivery_time_3": "Lungo termine (>6 settimane)",
                    "privacy-policy": "Privacy policy",
                    "gdpr_label": "Acconsento al trattamento della privacy<br><a href=\"#privacy-modal-1\" uk-toggle>leggi l'informativa</a>"
                }
            },
            "area_riservata": {
                "login": {
                    "label": "Area riservata",
                    "title": "Login",
                    "username": "Username",
                    "password": "Password",
                    "placeholder_1": "Inserisci il tuo indirizzo email",
                    "button": "Accedi",
                    "pwd_recovery": "Hai dimenticato la password?"
                },
                "account": {
                    "modifica_password": "Modifica password",
                    "logout": "Esci",
                    "email_subject": "Benvenuto nel nuovo Portale Clienti di MTG"
                },
                "ordini": {
                    "title": "Ordini cliente",
                    "ordina_per": "Ordina per",
                    "filtra_ordina": "Ordina e filtra",
                    "filtra_per": "Filtra per",
                    "mostra_piu": "Mostra di più",
                    "mostra_meno": "Mostra di meno",
                    "cerca_ordine": "Cerca ordine",
                    "vai_dettaglio": "Vai al dettaglio",
                    "vedi_allegati": "Vedi allegati",
                    "torna_elenco": "Torna all'elenco",
                    "resetta_filtri": "Resetta filtri",
                    "select_order_to_export": "Seleziona almeno un ordine da esportare",
                    "select": "Seleziona ordinamento",
                    "select_filter": "Seleziona",
                    "date": "Data conferma",
                    "year": "Anno",
                    "number": "N° ordine",
                    "code_internal": "Codice di riferimento interno",
                    "code_product": "Codice articolo",
                    "reference": "Vs. riferimento",
                    "shipment_status": "Stato spedizione",
                    "progress": "Stato avanzamento",
                    "non_evaso": "Non evaso",
                    "parzialmente_evaso": "Parzialmente evaso",
                    "evaso": "Evaso",
                    "export": "Esporta ordini",
                    "orders_title": "Ordini cliente",
                    "download": "Download",
                    "shipment_completed": "Evaso",
                    "partially_shipped": "Parzialmente evaso",
                    "processing": "Non evaso",
                    "download_docs": "Scarica documenti",
                    "no_download_docs": "Nessun download disponibile per questo ordine",
                    "order_line": "Riga ordine",
                    "row_total": "Totale riga",
                    "actual_quantity": "Quantità effettiva",
                    "shipping_status": "Stato spedizione",
                    "vr_codice_articolo": "Vostro codice Articolo:",
                    "vs_descrizione_articolo": "Vostra desc. Articolo:"
                },
                "table": {
                    "th_1": "Anno",
                    "th_2": "N° Ordine",
                    "th_3": "Vs. riferimento",
                    "th_4": "Data conferma ordine",
                    "th_5": "Codice resa (Incotermes)",
                    "th_6": "Importo totale",
                    "th_7": "Stato avanzamento",
                    "th_8": "Riga",
                    "th_9": "Articolo",
                    "th_10": "Quantità",
                    "th_11": "Prezzo",
                    "th_12": "Totale riga",
                    "th_13": "Note",
                    "th_14": "Data prevista spedizione",
                    "th_15": "Codice intrastat",
                    "th_16": "Avanzamento produzione (%)",
                    "th_17": "Stato spedizione"
                }
            }
        }
    },
    "en": {
        "rubinred": {
            "forms": {
                "forms": {
                    "message": {
                        "submission": {
                            "error": "Check the form below for errors."
                        }
                    }
                },
                "privacies": {
                    "common": {
                        "privacy_labels": {
                            "consent": "I agree",
                            "do_not_consent": "I disagree"
                        }
                    }
                }
            }
        },
        "frontend-message": {
            "delete_record": "You are about to delete this record, do you want to continue?",
            "not_logged_in": "You are not logged in.",
            "loading": "Processing Request",
            "check_form": "Check the form below for errors.",
            "something_wrong": "Oops, something went wrong (:code). If the problem persists contact us."
        },
        "frontend-action": {
            "add": "Add",
            "create": "Create",
            "remove": "Remove",
            "cancel": "Cancel",
            "delete": "Delete",
            "edit": "Edit",
            "submit": "Submit",
            "save": "Save",
            "copy": "Copy",
            "paste": "Paste",
            "update": "Update",
            "enable": "Enable",
            "disable": "Disable",
            "install": "Install",
            "uninstall": "Uninstall",
            "open": "Open",
            "close": "Close",
            "collapse": "Open/Close",
            "upload": "Upload",
            "export": "Export",
            "preview": "Preview",
            "view": "View",
            "play": "Play",
            "pause": "Pause",
            "stop": "Stop",
            "select": "Select",
            "select_language": "Select language",
            "select_languages": "Select languages",
            "select_all": "Select all",
            "select_element": "Select an element...",
            "select_elements": "Select one or more elements...",
            "drop_here": "Drop here",
            "load_more": "Load more",
            "send": "Send",
            "share": "Share",
            "download": "Download",
            "back": "Back",
            "logout": "Logout",
            "bulk": {
                "delete": "Delete Selected",
                "enable": "Enable Selected",
                "disable": "Disable Selected"
            }
        },
        "frontend-common": {
            "error": "Error",
            "success": "Success",
            "info": "Info",
            "warning": "Warning",
            "danger": "Danger",
            "yes": "Yes",
            "no": "No",
            "all": "All",
            "enabled": "Enabled",
            "disabled": "Disabled",
            "installed": "Installed",
            "uninstalled": "Uninstalled",
            "actions": "Actions",
            "bulk_actions": "Bulk Actions",
            "allow": "Allow",
            "deny": "Deny",
            "inherit": "Inherit",
            "read_only": "Read only",
            "reset": "Reset",
            "refresh": "Refresh",
            "profile": "Profile",
            "no_results": "No Results",
            "showing": "Showing",
            "to": "to",
            "in": "in",
            "of": "of",
            "entries": "entries",
            "loading": "Loading",
            "search": "Search",
            "filters": "Filters",
            "order": "Order",
            "remove_filter": "Remove filter",
            "show_all": "Show all",
            "show_enabled": "Show enabled",
            "show_disabled": "Show disabled",
            "show_more": "Show more",
            "show_less": "Show less",
            "all_enabled": "All Enabled",
            "all_disabled": "All Disabled",
            "per_page": "Per page",
            "language": "Language",
            "words_count": "{0} No words|{1} One word|[2,Inf] :count words",
            "preset": "Preset",
            "presets": "Presets",
            "privacy_policy": "Privacy policy",
            "company_info": "Company info",
            "safe_purchase": "Safe purchase"
        },
        "frontend-mtg": {
            "filters": {
                "sectors": "Sectors",
                "filter_products": "Filters ",
                "active_filters": "Active filters ",
                "filter_by": "Filter by ",
                "remove": "Remove",
                "reset_all": "Reset filters/ Clear all filters ",
                "apply": "Enter",
                "material": "Material",
                "liquid": "Liquid/material",
                "regulations": "Regulations",
                "applications": "Applications "
            },
            "configurator": {
                "material": "Material",
                "application": "Application",
                "sector": "Sectors",
                "tube_type_standard": "Standard",
                "tube_type_special": "Special ",
                "special_fitting": "Special fitting",
                "special_text": "In the next step you can upload the technical drawing of the special fitting",
                "dimensions": "Dimensions",
                "inner_dimensions": "Inner dimension (mm)",
                "delivery_time": "Delivery time (weeks)",
                "connectors": "Fittings ",
                "summary": "Order summary ",
                "inner_dimension_info_1": "For values up to 254mm, the maximum available length is 40m. For values greater than 254mm, the maximum available length is 12m.",
                "inner_dimension_info_2": "For values between 5mm and 10mm, and between 150mm and 200mm, standard fittings are not available.",
                "length_info_1": "For values up to 12m, the maximum pressure is 15 BAR. For values greater than 12m, the maximum pressure is 40 BAR.",
                "fitting_file_format": "Allowed file types : jpg, jpeg, png. (Maximum file size: 2 Mbyte)",
                "fitting_file_right": "Upload right fitting drawing ",
                "fitting_file_left": "Upload left fitting drawing ",
                "select_file": "Select the file/choose the file/add file ",
                "file_fitting_right_field": "Right fitting file",
                "file_fitting_left_field": "Left fitting file ",
                "file_error": "Invalid file type selected. Allowed file types : jpg, jpeg, png. (Maximum file size: 2 Mbyte)",
                "1_title": "Find the hose that best suits your needs. <br>Choose the <strong>material</strong> or the <strong>application sector. </strong>",
                "select_tube_size": "Choose hose dimensions",
                "select_the": "Select",
                "select": "Select ",
                "select_category": "Select the category ",
                "proceed": "Next ",
                "back": "Previous ",
                "total_meters": "Total length (m)",
                "total_length_meters": " Rolls length (m)",
                "operating_pressure": "Working pressure (bar)",
                "select_connectors": "Choose fittings",
                "select_dimension": "Select the fitting dimension ",
                "left": "Left",
                "left_connector": "Left fitting ",
                "right": "Right ",
                "right_connector": "Right fitting ",
                "no_connector": "No fitting ",
                "order_summary": "Order summary ",
                "quantity": "Quantity ",
                "company_name": "Company name",
                "name": "Contact name ",
                "phone": "Telephone",
                "province": "Province",
                "email": "E-mail",
                "notes": "Note",
                "select_tube_by": "Select tube by",
                "inner_dimension": "Inner dimension",
                "total_length": "Total length",
                "pressure": "Pressure",
                "connector_left_category": "Left fitting category",
                "connector_left_element": "Left fitting",
                "connector_left_size": "Left fitting size",
                "connector_right_category": "Right fitting category",
                "connector_right_element": "Right fitting",
                "connector_right_size": "Right fitting size",
                "special_connector_right_file": "Special right fitting file",
                "special_connector_left_file": "Special left fitting file",
                "submit": "Confirm",
                "material_item": "Specify material type (optional)",
                "email_subject": "New configurator request",
                "email_text": "Following the summary of the configurator request:",
                "material_label": "Material",
                "application_label": "Application",
                "form_data": {
                    "standard": "Standard",
                    "special": "Special fitting",
                    "material_1": "Rubber",
                    "material_2": "Silicone",
                    "material_3": "Thermoplastic",
                    "material_4": "Fluoropolymer",
                    "material_item_1": "EPMD",
                    "material_item_2": "NR",
                    "material_item_3": "NBR",
                    "material_item_4": "SBR",
                    "material_item_5": "FKM",
                    "material_item_6": "Platinic",
                    "material_item_7": "Peroxide ",
                    "material_item_8": "upe",
                    "material_item_9": "Xlpe",
                    "material_item_10": "PU-etere",
                    "material_item_11": "Pu-estere",
                    "material_item_12": "Pu-antistatic",
                    "material_item_13": "PFA",
                    "material_item_14": "FEP",
                    "material_item_15": "PTFE",
                    "material_item_16": "PFA antistatic",
                    "material_item_17": "FEP antistatic",
                    "material_item_18": "PFE antistatic",
                    "alimentare": "Food",
                    "farmaceutico": "Pharmaceutical",
                    "chimico": "Chemical",
                    "ferroviario": "Railway ",
                    "pompe_peristaltiche_e_valvole": "Peristaltic pumps and valves",
                    "peristaltiche": "Peristaltic pumps",
                    "dragaggio_e_materiali_abrasivi": "Dredging operations and abrasive materials",
                    "inner_dimension_1": "Inner dimension 1 ",
                    "inner_dimension_2": "Inner dimension 2",
                    "inner_dimension_3": "Inner dimension 3",
                    "inner_dimension_4": "Inner dimension 4",
                    "inner_dimension_5": "Inner dimension 5",
                    "inner_dimension_6": "Inner dimension 6",
                    "inner_dimension_7": "Inner dimension 7",
                    "inner_dimension_8": "Inner dimension 8",
                    "delivery_time_1": "Urgent/Express",
                    "delivery_time_2": "Standard (3-6 weeks)",
                    "delivery_time_3": "Long term (>6 weeks)",
                    "privacy-policy": "Privacy policy",
                    "gdpr_label": "I accept the<br><a href=\"#privacy-modal-1\" uk-toggle>privacy policy</a>"
                },
                "box": {
                    "title": "We design and manufacture custom rubber hoses for every need",
                    "text": "We advise, design and provide customized solutions to meet your needs and specifications."
                }
            },
            "area_riservata": {
                "login": {
                    "label": "Reserved area",
                    "title": "Login",
                    "username": "Username",
                    "password": "Password",
                    "placeholder_1": "Please enter your email address",
                    "button": "Log in",
                    "pwd_recovery": "Did you forget your password?"
                },
                "account": {
                    "modifica_password": "Edit password",
                    "logout": "Exit",
                    "email_subject": "Welcome to MTG's New Customer Portal"
                },
                "ordini": {
                    "title": "Customer orders",
                    "ordina_per": "Sort by",
                    "filtra_ordina": "Sort and filter",
                    "filtra_per": "Filter by",
                    "mostra_piu": "Show more",
                    "mostra_meno": "Show less",
                    "cerca_ordine": "Search order",
                    "vai_dettaglio": "Go to detail",
                    "vedi_allegati": "Download attachments",
                    "torna_elenco": "Return to list",
                    "resetta_filtri": "Reset filters",
                    "select_order_to_export": "Select at least one order to export",
                    "select": "Select sorting",
                    "select_filter": "Select",
                    "date": "Confirmation date",
                    "year": "Year",
                    "number": "Order no",
                    "code_product": "Article code",
                    "code_internal": "Internal reference code",
                    "reference": "Your reference",
                    "shipment_status": "Shipping status",
                    "progress": "Progress",
                    "non_evaso": "Processing",
                    "parzialmente_evaso": "Partially shipped",
                    "evaso": "Shipment completed",
                    "shipment_completed": "Shipment completed",
                    "partially_shipped": "Partially shipped",
                    "processing": "Processing",
                    "export": "Order export",
                    "orders_title": "Customer orders",
                    "download": "Download",
                    "download_docs": "Download documents",
                    "no_download_docs": "No downloads available for this order",
                    "order_line": "Order line",
                    "row_total": "Row total",
                    "actual_quantity": "Actual quantity",
                    "shipping_status": "Shipping status",
                    "quantity": "Quantity",
                    "vr_codice_articolo": "Your article code:",
                    "vs_descrizione_articolo": "Your desc. Item:"
                },
                "table": {
                    "th_1": "Year",
                    "th_2": "Order No",
                    "th_3": "Your reference",
                    "th_4": "Order confirmation date",
                    "th_5": "Return code (Incotermes)",
                    "th_6": "Total amount",
                    "th_7": "Progress",
                    "th_8": "Line",
                    "th_9": "Item",
                    "th_10": "Quantity",
                    "th_11": "Price",
                    "th_12": "Row total",
                    "th_13": "Note",
                    "th_14": "Estimated shipping date",
                    "th_15": "Intrastat code",
                    "th_16": "Production progress (%)",
                    "th_17": "Shipping status"
                }
            }
        }
    },
    "zh": {
        "rubinred": {
            "forms": {
                "forms": {
                    "message": {
                        "submission": {
                            "error": "检查表单中的错误。"
                        }
                    }
                }
            }
        }
    }
};


// WEBPACK FOOTER //
// ./public/themes/frontend/mtg/assets/js/translations.js